class Database {
    private database: string;
    constructor(database: string) {
        this.database = database;
    }
    private getDb(): any {
        const data = localStorage.getItem(this.database) || '{}';
        return JSON.parse(data);
    }
    getBoolean(name: string, defaultValue?: boolean): boolean {
        const json = this.getDb();
        if (name in json) {
            return Boolean(json[name]);
        } else {
            return defaultValue ?? false;
        }
    }
    setBoolean(name: string, value: boolean): void {
        const json = this.getDb();
        json[name] = value;
        const newData = JSON.stringify(json);
        localStorage.setItem(this.database, newData);
    }
    getNumber(name: string, defaultValue?: number): number {
        const json = this.getDb();
        if (name in json) {
            return Number(json[name]);
        } else {
            return defaultValue ?? 0;
        }
    }
    setNumber(name: string, value: number): void {
        const json = this.getDb();
        json[name] = value;
        const newData = JSON.stringify(json);
        localStorage.setItem(this.database, newData);
    }
    getString(name: string, defaultValue?: string): string {
        const json = this.getDb();
        if (name in json) {
            return String(json[name]);
        } else {
            return defaultValue ?? "";
        }
    }
    setString(name: string, value: string): void {
        const json = this.getDb();
        json[name] = value;
        const newData = JSON.stringify(json);
        localStorage.setItem(this.database, newData);
    }
}

const localDatabase = new Database('bswap');

export default localDatabase